import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { CookieService } from './cookie-service';
import { LocationService } from './location-service';

export const LanguageService = Symbol('LanguageService');

export interface LanguageService {
    /**
     * 获取当前语言
     */
    getCurrentLanguage(): string;
    /**
     * 是否中文环境
     */
    isZh(): boolean;
}

export namespace LanguageService {
    export type Language = 'cn' | 'tw' | 'en' | 'jp';
}

@injectable()
export class LanguageServiceImpl implements LanguageService {
    static PATTERN = /---uniform-setting-locale=(\w+)/;

    private _locale: LanguageService.Language | undefined;

    constructor(
        @inject(CookieService)
        private _cookieService: CookieService,
        @inject(LocationService)
        private _locationService: LocationService,
    ) {

    }

    getCurrentLanguage(): LanguageService.Language {
        if (!this._locale) {
            let locale: LanguageService.Language | undefined;
            const data = this._cookieService.match(LanguageServiceImpl.PATTERN) || [];
            locale = data[1] as LanguageService.Language;
            if (locale && ['cn', 'tw', 'en', 'jp'].indexOf(locale) === -1) {
                locale = undefined;
            }
            if (!locale) {
                const host = this._locationService.host;
                if (host.indexOf('.patsnap.') > -1) {
                    locale = 'en';
                }
                else if (host.indexOf('.zhihuiya.') > -1) {
                    locale = 'cn';
                }
            }
            this._locale = locale || 'en';
        }

        return this._locale;
    }

    isZh(): boolean {
        const locale = this.getCurrentLanguage();
        return locale === 'cn' || locale === 'tw';
    }
}
